import type { ComponentType } from "react";
import * as D from "@/components/ui/dialog";
import * as S from "@/components/ui/sheet";
import * as I from "@/components/ui/input";
import * as L from "@/components/ui/label";
import * as W from "@/components/ui/switch";
import * as M from "@/components/ui/dropdown-menu";

// Typed bridge for the JS shadcn components
type Any = ComponentType<any>;
export const Dialog = D.Dialog as Any;
export const DialogContent = D.DialogContent as Any;
export const DialogHeader = D.DialogHeader as Any;
export const DialogTitle = D.DialogTitle as Any;
export const Sheet = S.Sheet as Any;
export const SheetContent = S.SheetContent as Any;
export const SheetHeader = S.SheetHeader as Any;
export const SheetTitle = S.SheetTitle as Any;
export const SheetTrigger = S.SheetTrigger as Any;
export const Input = I.Input as Any;
export const Label = L.Label as Any;
export const Switch = W.Switch as Any;
export const DropdownMenu = M.DropdownMenu as Any;
export const DropdownMenuTrigger = M.DropdownMenuTrigger as Any;
export const DropdownMenuContent = M.DropdownMenuContent as Any;
export const DropdownMenuItem = M.DropdownMenuItem as Any;
